'use strict';
var nativeError = console.error;
//导入框架包
var React = require('react');
var ReactDOM = require('react-dom');
var Provider = require('react-redux').Provider;
var RemotePreviewHelp = require('./views/RemotePreviewHelp');
var envHelper = require('./helper/envHelper');
var storeHelper = require('./helper/storeHelper');
var IOSWarning = require('./views/IOSWarning');
var AppError = require('./views/AppError');
var i18n = require('./helper/i18n');
var logHelper = require('./helper/logHelper');
var Preview;
var appPath;
require('./less/style.less');

var configHelper = require('./helper/configHelper');
var projectLoadHelper = require('./helper/projectLoadHelper');

var AppStore = require('./stores/AppStore');
var Authorization = require('./views/Authorization');

if (window.isDev) {
} else {
  console.log = function () {
  };
  console.warn = function () {
  };
  console.error = function (e) {
    logHelper.error(e, true);
    nativeError.apply(this, arguments);
  };
}

window.onerror = function (msg, url, lineNo, columnNo, error) {
  var string = msg.toLowerCase();
  var substring = 'script error';
  if (string.indexOf(substring) > -1) {
    console.log('see browser console for details');
    logHelper.onerror('see browser console for detailssee browser console for details');
  } else {
    logHelper.onerror(msg, url, lineNo, columnNo, error);
  }
};

//判断设备，设置路径参数
if (envHelper.isMobileDevice()) {
// if (true) {
  Preview = require('./views/MobilePreview');
  appPath = 'data/项目.mp';
} else {
  Preview = require('./views/PCPreview');
  appPath = storeHelper.get('path') || window.path || 'data/test9.mt';
  appPath = 'data/项目.mp';
  // appPath = 'data/test.mp';
}

function renderWeChatGuide(name, logo) {
  ReactDOM.render(
    <IOSWarning name={name} logo={logo} arrowClassName="top-right">
      <p>{i18n.get('CLICK_MENU')}</p>
      <p>{i18n.get('OPEN_IN_SAFARI')}</p>
    </IOSWarning>,
    document.getElementById('container')
  );
}

function renderQQGuide(name, logo) {
  ReactDOM.render(
    <IOSWarning name={name} logo={logo} arrowClassName="top-right">
      <p>{i18n.get('CLICK_MENU')}</p>
      <p>{i18n.get('OPEN_IN_SAFARI')}</p>
    </IOSWarning>,
    document.getElementById('container')
  );
}

function renderSafariGuide(name, logo) {
  ReactDOM.render(
    <IOSWarning name={name} logo={logo} arrowClassName="bottom-center">
      <p>
        {i18n.get('CLICK_DOWN')} <img
        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAA1CAQAAACHdlEQAAAAiklEQVR4Ae3RQQrCQAyF4X+kd+hp5jyB8fZ6gLiSh8hAmBRRm3/RVfh4TAllGAc1cJxxHCUuT4nLUld9GVkKHAdxCeqJiUtQwsStU8IWuJ37y7kwcTd2gnUMphgYnYWEBboQ74exDWde4z3/1DItCDa79f/5m4UVVlhhG5FavVlhhRV2LqzhX7rsATJGRfK0Ul+XAAAAAElFTkSuQmCC"
        width="20"
        alt="share"/>
      </p>
      <p>
        {i18n.get('ADD_HOME')}
      </p>
    </IOSWarning>,
    document.getElementById('container')
  );
}

function renderRemoteWarning() {
  ReactDOM.render((
    <RemotePreviewHelp/>
  ), document.getElementById('container'));
}

//渲染预览界面
function renderPreview(app, config) {
  var store = AppStore({
    app: app,
    config: config
  });
  ReactDOM.render((
    <Provider store={store}>
      <Preview path={appPath}/>
    </Provider>
  ), document.getElementById('container'));
}

function renderError(err) {
  console.error(err);
  ReactDOM.render((
    <AppError error={err}/>
  ), document.getElementById('container'));
}

function createIcon(icon) {
  var link = document.createElement('link');
  link.rel = 'apple-touch-icon';
  link.href = icon;
  document.getElementsByTagName('head')[0].appendChild(link);
}

function isNotMobileProject(platform) {
  return platform !== 'MtMobile' && platform !== 'MtPad';
}

function previewApp(app) {
  window.document.title = app.name;
  var platform = app.params.projectParam.platform;
  if (envHelper.isMobileDevice() && isNotMobileProject(platform)) {
    return renderError(new Error(i18n.get('NOT_AVAILABLE_ON_MOBILE')));
  }
  configHelper.getConfig(function (err, config) {
    if (err) {
      return renderError(err);
    }
    if (isNotMobileProject(platform)) {
      config.showQRCode = true; // 非移动项目, 不显示二维码
    }
    createIcon(config.logo);
    if (envHelper.isiOS() && !envHelper.isStandalone() && configHelper.notForceUseCurrentBrowser() && config.iOSGuide) {
      if (envHelper.isWeChat()) {
        return renderWeChatGuide(app.name, config.logo);
      } else if (envHelper.isQQ()) {
        return renderQQGuide(app.name, config.logo);
      }
      return renderSafariGuide(app.name, config.logo);
    }
    return renderPreview(app, config);
  });
}

function authorization() {
  ReactDOM.render(<Authorization/>, document.getElementById('container'));
}

/*
 * 执行
 * */
if (window.remote && document.location.protocol.indexOf('http') !== 0) { // 是远程加载,但是该页面却不是 http/https 的
  renderRemoteWarning();
} else {
  projectLoadHelper.loadApp(appPath, function (err, app, statusCode) {
    if (err) {
      if (statusCode === 401) {
        return authorization();
      }
      return renderError(err);
    }
    previewApp(app);
  });
}



// WEBPACK FOOTER //
// ./src/lib.js